import { fabric } from 'fabric';
import ShapeResizeControl from './ShapeResizeControl';

const ROTATE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="#999999" d="M496 48V192c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94c14.22-10.53 34.22-7.75 44.81 6.375c10.59 14.16 7.75 34.22-6.375 44.81c-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256s100.5-223.9 223.9-223.9c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32S496 30.31 496 48z"/></svg>`;

class ShapeRotateControl extends ShapeResizeControl {
  offsetX = -20;
  offsetY = 20;
  cursorStyle = 'grab';
  cornerSize = 16;

  static icon: HTMLImageElement;

  static prepareIcon() {
    this.icon = new Image();
    this.icon.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      ROTATE_ICON
    )}`;
    // Decode conditionally to workaround jest tests running in node not a browser.
    this.icon.decode && this.icon.decode();
  }

  render(ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;

    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(ShapeRotateControl.icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  }
}
ShapeRotateControl.prepareIcon();

export default ShapeRotateControl;
